import React, { useState } from "react";
import { useListAndSearchAllInvestments } from "@rentablo/api/apiv1";
import { Depot } from "../stateMachine/types/depots";
import { NameAndDepotStep } from "./NameAndDepotStep";

export interface Props {
  handleNext: (depotId: number, name: string, comment?: string) => void;
  handleNewDepot: (name: string, comment?: string) => void;
  handlePrevious: () => void;
  defaultName: string;
  defaultComment?: string;
  selectedDepotId?: number;
  selectableDepots: Depot[];
  isin?: string;
  tickerSymbol?: string;
  quoteProvider?: string;
}

export const NameAndDepotStepWithLookup = ({
  handleNext,
  handleNewDepot,
  handlePrevious,
  defaultName,
  defaultComment,
  selectedDepotId,
  selectableDepots,
  isin,
  tickerSymbol,
  quoteProvider,
}: Props) => {
  const [depotId, setDepotId] = useState<number | undefined>(selectedDepotId);
  const handleDepotIdChange = (id: number) => {
    setDepotId(id);
  };

  const handleNextWrapper = (name: string, comment?: string) => {
    if (!depotId) return;
    handleNext(depotId, name, comment);
  };

  const tickerLookup = !isin && tickerSymbol ? [tickerSymbol] : undefined;

  const { data: investmentList } = useListAndSearchAllInvestments(
    {
      accountId: depotId ? [depotId] : undefined,
      isin: isin ? [isin] : undefined,
      tickerSymbol: tickerLookup,
      includeHistoric: false,
    },
    { enabled: !!depotId && (!!isin || !!tickerLookup) }
  );

  const investments = investmentList?.investments ?? [];

  const investment = tickerLookup
    ? investments.find((it) => it.quoteProvider === quoteProvider)
    : investments[0];

  return (
    <NameAndDepotStep
      handleNext={handleNextWrapper}
      handleNewDepot={handleNewDepot}
      handlePrevious={handlePrevious}
      defaultName={defaultName}
      defaultComment={defaultComment}
      selectedDepotId={depotId}
      handleDepotIdChange={handleDepotIdChange}
      selectableDepots={selectableDepots}
      existingLots={investment?.numberOfLots ?? 0}
    />
  );
};
